var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLoyaltyLeafLogoMinimal = function SvgIconLoyaltyLeafLogoMinimal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(255,255,255,0)",
    stroke: "#061e21",
    "data-name": "Ellipse 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#061e21",
    d: "M10.241 27.369a.705.705 0 0 1-.563-.682 2.3 2.3 0 0 1-.011-.371.95.95 0 0 1 .833-.973 3.2 3.2 0 0 0 1.237-.5 3.2 3.2 0 0 0 .93-.969 8.5 8.5 0 0 0 .672-1.2c.361-.832.66-1.692 1.017-2.528a10.8 10.8 0 0 1 2.546-3.78 4.9 4.9 0 0 1 1.314-.912 4 4 0 0 1 .412-.131l.058.081a12.5 12.5 0 0 0-2.362 3.01 14.4 14.4 0 0 0-1.33 3.627c.245-.021.48-.027.708-.063a8.51 8.51 0 0 0 6.665-5.05 17.3 17.3 0 0 0 1.432-4.961c.057-.381.094-.763.139-1.143a1 1 0 0 0-.027-.076c-.324 0-.662-.008-1 0a11.35 11.35 0 0 0-6.126 1.818 8.47 8.47 0 0 0-3.739 5.251 9.2 9.2 0 0 0-.121 3.047c.017.173.023.348.034.522l-.056.024a1 1 0 0 1-.126-.233 14 14 0 0 1-.377-1.669 8.6 8.6 0 0 1 .559-4.384 8.4 8.4 0 0 1 2.708-3.393 9.8 9.8 0 0 1 4.877-2.023c.929-.124 1.865-.215 2.782-.4.821-.165 1.622-.437 2.433-.661a1.7 1.7 0 0 1 .321-.06c.2-.014.275.067.248.268a1.8 1.8 0 0 1-.1.416 35 35 0 0 0-1.407 5.045 14.6 14.6 0 0 1-2.374 5.293 8.97 8.97 0 0 1-5.264 3.607c-.864.216-1.746.355-2.624.516a.27.27 0 0 0-.224.2 7.6 7.6 0 0 1-1.377 2.267 3.64 3.64 0 0 1-2.014 1.188 1.6 1.6 0 0 1-.3.027 2 2 0 0 1-.403-.045"
  })));
};
export default SvgIconLoyaltyLeafLogoMinimal;